import { useState, useCallback } from "react";

// hook for managing table row selection
export const useRowSelection = () => {
  const [selectedRowIds, setSelectedRowIds] = useState([]);

  const handleSelectAll = useCallback((data) => {
    setSelectedRowIds(data.map((row) => row.id));
  }, []);

  const handleUnselectAll = useCallback(() => {
    setSelectedRowIds([]);
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedRowIds([]);
  }, []);

  return {
    selectedRowIds,
    setSelectedRowIds,
    handleSelectAll,
    handleUnselectAll,
    clearSelection,
  };
};
